import React from 'react';
import { subscribeCarePlanReviews, subscribeCarePlans } from './carePlanService';

const STATUS_PRIORITY = { waiting: 0, in_progress: 1, suggested: 2 };

export const sortPlansForHome = (plans = []) => [...plans].sort((left, right) => {
  const statusDifference = (STATUS_PRIORITY[left.status] ?? 9) - (STATUS_PRIORITY[right.status] ?? 9);
  if (statusDifference) return statusDifference;
  if (left.targetDateText && !right.targetDateText) return -1;
  if (!left.targetDateText && right.targetDateText) return 1;
  return Number(right.updatedAt?.toMillis?.() || 0) - Number(left.updatedAt?.toMillis?.() || 0);
});

const useCarePlans = (childId = '') => {
  const [plans, setPlans] = React.useState([]);
  const [loading, setLoading] = React.useState(Boolean(childId));
  const [reviews, setReviews] = React.useState([]);
  React.useEffect(() => subscribeCarePlans(childId, (items) => {
    setPlans(items);
    setLoading(false);
  }, () => setLoading(false)), [childId]);
  React.useEffect(() => subscribeCarePlanReviews(childId, setReviews, () => {}), [childId]);
  const activePlans = plans.filter((plan) => plan.status !== 'completed');
  return { plans, reviews, reviewCount: reviews.length, loading, homePlans: sortPlansForHome(activePlans).slice(0, 3) };
};

export default useCarePlans;
